var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0237 8.90419L11.5572 8.37061C12.2686 7.65912 13.422 7.65912 14.1334 8.37061C14.8448 9.08197 14.8448 10.2354 14.1334 10.9468L10.4901 14.59C9.77871 15.3015 8.62533 15.3015 7.91392 14.59L4.27065 10.9468C3.55924 10.2354 3.55924 9.08197 4.27065 8.37061C4.98205 7.65912 6.13543 7.65912 6.84684 8.37061L7.38038 8.90419V2.37213C7.38034 1.36601 8.19592 0.550476 9.202 0.550476C10.2081 0.550476 11.0237 1.36601 11.0237 2.37213V8.90419ZM1.91541 21.4994C0.909327 21.4994 0.09375 20.6839 0.09375 19.6778C0.09375 18.6716 0.909327 17.8561 1.91541 17.8561H16.4886C17.4947 17.8561 18.3102 18.6716 18.3102 19.6778C18.3102 20.6839 17.4947 21.4994 16.4886 21.4994H1.91541Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e9e08462692c9586692366198bfc981c.svg";
export { ForwardRef as ReactComponent };